import script from "./TrackPointElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./TrackPointElement.vue?vue&type=script&lang=ts&setup=true"

import "./TrackPointElement.vue?vue&type=style&index=0&id=f5646142&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5646142"]])

export default __exports__